module.exports = __webpack_public_path__ + "static/media/Forgot Password 2.376ce9c2.svg";